import React from 'react';
import '../assets/css/morebutton.css'
import MultiLingualContent from "../config/multilingualContent";

const MoreButton = () => {
    return (
        <button className="ms-auto"><span><MultiLingualContent contentID="seemore" /></span></button>
    );
};

export default MoreButton;